import { CEPersonBase } from './ce-person-base'


export class CEPerson extends CEPersonBase {

}